<template>
  <div class="descriptionPage">
    <el-page-header @back="goBack"> </el-page-header>
    <div class="title">用户须知</div>
    <div class="content">
      <template>
        <div style="font-size: 15px; line-height: 30px; padding-bottom: 82px">
          <slot name="content"></slot>
        </div>
      </template>
    </div>
    <div class="btnBox">
      <el-checkbox v-model="checked"
        >勾选即表示您同意并接受以上条款</el-checkbox
      >
      <div class="btn">
        <el-button type="primary" size="medium" @click="enter">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: false,
    };
  },
  mounted() {},
  methods: {
    goBack() {
      this.$emit("goBack");
    },
    enter() {
      if (this.checked == false) {
        this.$message.warning("请阅读并勾选用户须知");
      } else {
        this.$emit("enter");
      }
    },
  },
  watch: {},
};
</script>
<style lang="less">
.descriptionPage .el-dialog__body {
  padding: 10px 20px;
}
</style>
<style lang="less" scoped>
.descriptionPage {
  .title {
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 20px;
  }
  .content {
    padding: 20px 300px;
    line-height: 25px;
  }
  .btnBox {
    width: 100%;
    position: fixed;
    bottom: 35px;
    background-color: rgb(243, 244, 248);
    padding-bottom: 17px;
    padding-top: 10px;
    // left: calc(50% - 82px);
    text-align: center;
    .btn {
      margin-top: 10px;
    }
  }
}
</style>